interface AILoaderProps {
  size?: number
  text?: string
  style?: React.CSSProperties
  className?: string
}

// theutkarshmail/ai-loader — letters + rotating inset glow circle
export function AILoader({ size = 180, text = 'Generating', style, className }: AILoaderProps) {
  const letters = text.split('')
  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(to bottom, #1a3379, #0f172a, #000)',
        overflow: 'hidden',
        ...style,
      }}
    >
      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Inter, system-ui, sans-serif',
          userSelect: 'none',
          width: size,
          height: size,
        }}
      >
        {letters.map((letter, i) => (
          <span
            key={i}
            style={{
              display: 'inline-block',
              color: 'white',
              opacity: 0.4,
              fontSize: 16,
              fontWeight: 600,
              animation: 'ail-letter 3s infinite',
              animationDelay: `${i * 0.1}s`,
            }}
          >
            {letter}
          </span>
        ))}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            animation: 'ail-circle 5s linear infinite',
          }}
        />
      </div>
      <style>{`
        @keyframes ail-circle {
          0% {
            transform: rotate(90deg);
            box-shadow:
              0 6px 12px 0 #38bdf8 inset,
              0 12px 18px 0 #005dff inset,
              0 36px 36px 0 #1e40af inset,
              0 0 3px 1.2px rgba(56,189,248,0.3),
              0 0 6px 1.8px rgba(0,93,255,0.2);
          }
          50% {
            transform: rotate(270deg);
            box-shadow:
              0 6px 12px 0 #60a5fa inset,
              0 12px 6px 0 #0284c7 inset,
              0 24px 36px 0 #005dff inset,
              0 0 3px 1.2px rgba(56,189,248,0.3),
              0 0 6px 1.8px rgba(0,93,255,0.2);
          }
          100% {
            transform: rotate(450deg);
            box-shadow:
              0 6px 12px 0 #4dc8fd inset,
              0 12px 18px 0 #005dff inset,
              0 36px 36px 0 #1e40af inset,
              0 0 3px 1.2px rgba(56,189,248,0.3),
              0 0 6px 1.8px rgba(0,93,255,0.2);
          }
        }
        @keyframes ail-letter {
          0%, 100% { opacity: 0.4; transform: translateY(0); }
          20% { opacity: 1; transform: scale(1.15); }
          40% { opacity: 0.7; transform: translateY(0); }
        }
      `}</style>
    </div>
  )
}
